"use client";

import { useState, type ComponentProps } from "react";

import { Input } from "@traqly/ui/components/input";
import {
  EyeVisibilityIcon,
  EyeVisibilityOffIcon,
} from "@traqly/ui/icons/eye-icon";

import { Show } from "./show";

type PasswordInputProps = Omit<
  ComponentProps<typeof Input>,
  "type" | "trailingIcon"
>;

function PasswordInput(props: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Input
      type={showPassword ? "text" : "password"}
      trailingIcon={
        <div className="flex items-center justify-center">
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="text-mono-600 hover:text-mono-900 focus:outline-none"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <Show when={showPassword}>
              <EyeVisibilityOffIcon className="size-6" />
            </Show>

            <Show when={!showPassword}>
              <EyeVisibilityIcon className="size-6" />
            </Show>
          </button>
        </div>
      }
      {...props}
    />
  );
}

PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
